<template>
  <section class="mb-50 lg:mb-110">
    <div  class="container">
      <div class="grid">
        <div v-if="data_etape0.field_texte_home_encart != ''" class="col-span-full lg:col-span-5 relative">
          <span class="jumperSimple absolute top-0 left-0">{{ data_etape0.field_cavalier_home_encart }}</span>
          <div class="bg-black poCardFiberMedium c-white pt-40 lg:pt-50 pb-25 lg:pb-50 px-30 lg:px-50 min-h-160 font-bold">
            <div class="richContent" v-html="data_etape0.field_texte_home_encart">
            </div>
          </div>
        </div>

        <div class="col-span-full lg:col-span-7 lg:order-first">
          <h2 v-if="data_etape0.field_titre_home != ''" class="title-default mb-20 lg:mb-40">{{ data_etape0.field_titre_home }}</h2>

          <p v-if="data_etape0.field_surtitre_cta_1_home != ''" class="font-bold lg:text-lg lg:leading-24 mb-25 lg:mb-34">{{ data_etape0.field_surtitre_cta_1_home }}</p>

          <div v-if="data_etape0.field_cta_1_home[0].url == ''" class="mb-30 lg:mb-50">
            <button @click="$emit('switchToEtape1');taggage('hp_configurateur_open', 'commencer_la_configuration', parcours.currentUrl, { tealium_event: 'select_content' })" class="btn btn--md btn--fill-dark w-full max-w-400 lg:w-300">{{ data_etape0.field_cta_1_home[0].title }}</button>
          </div>

          <p v-if="data_etape0.field_surtitre_cta_2_home.url != ''" class="lg:text-lg lg:leading-24 mb-25 md:mb-20 lg:mb-34">{{ data_etape0.field_surtitre_cta_2_home }}</p>

          <div v-if="data_etape0.field_cta_2_home[0].url != ''">
            <a @click="taggage('hp_configurateur_open', 'prendre_rdv_pack_open', data_etape0.field_cta_2_home[0].url, { tealium_event: 'select_content' })" class="btn btn--md btn--fill-transp w-full max-w-400 lg:w-300" target="_blank" :href="data_etape0.field_cta_2_home[0].url" :title="data_etape0.field_cta_2_home[0].title">{{ data_etape0.field_cta_2_home[0].title }}</a>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';
import { onMounted } from 'vue';
import { taggage, taggageView, resetTag } from '@/utils/taggage.js';


const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});



const error_etape0 = ref(null);

const currentUrl = window.location.href;

defineEmits(['switchToEtape1']);

onMounted(async () => {
  try {
    //console.log('Etape0Inner mounted');
    taggageView('mobile web', 'Orange', '', 'portail', 'RES', 'global', 'pack_open_homepage', 'Pack Open', 'internet', window.devicePixelRatio);
  } catch (e) {
    error_etape0.value = e.message;
  }
});
</script>

//taggageView(canal, couleur, departement, domaine, segment, sous_univers, titre_page, type_page, univers, device_pixel_ratio) {
